<template>
  <div id="Content">
    <Header></Header>
    <b-container fluid>
      <b-row>
        <LeftNav :items="navbarItems"></LeftNav>
        <b-col>
          <b-row>
            <b-col class="new-config px-5 py-3">
              <router-view />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LeftNav from '@/components/TheLeftNav'
import Header from '@/components/layout/Header'
import { sweepAll, sweepAllByKey } from '@/api/web'
export default {
  name: 'Cache',
  components: {
    LeftNav,
    Header
  },
  data () {
    return {
      navbarItems: [
        {
          name: 'ContentRecharge',
          text: 'Recharge',
          icon: 'attach_money'
        },
        {
          name: 'ContentICG',
          text: 'ICG',
          icon: 'view_list'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'loader/isLoading'
    })
  },
  methods: {
    save () {
      var promises = []
      this.cacheItems.forEach((item) => {
        if (item.checked) {
          promises.push(sweepAllByKey(item.key))
        }
      })
      Promise.all(promises).then(() => {
        this.cacheItems.forEach((item) => {
          item.checked = false
        })
      }).catch(() => {
        alert('Some of the key could not be cleaned!')
      })
    },
    dump () {
      sweepAll()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/content/Index.vue